import TelesoftSyncChargeManager from './TelesoftSyncChargeManager.js';

export default class BackofficeInvoiceManagementIndex {
    constructor() {
      this.telesoftSyncChargeManager = new TelesoftSyncChargeManager();
      this.initializeDataTable();
      this.bindEvents();
      this.bindChargeCreationModal();
    }
  
    initializeDataTable() {
      if ($.fn.DataTable.isDataTable('#invoice-management-datatable')) {
        $('#invoice-management-datatable').DataTable().destroy();
      }
  
      this.table = $('#invoice-management-datatable').DataTable({
        "language": {
          "url": '/data-tables/locales/' + I18n.locale + '.json'
        },
        "pageLength": 25,
        "order": [[3, "desc"]], // Order by last modification date descending
        "columnDefs": [
          { "orderable": false, "targets": [6] }, // Disable ordering on Actions column
        ],
        "responsive": true,
        "searching": true, // Keep searching enabled
        "dom": 'Bfrtip', // Remove 'f' to hide default search box, keep buttons
        "buttons": [
          {
            extend: 'excel',
            text: 'Export Excel',
            filename: function() {
              return 'nexloop_gestion_factures_' + new Date().toISOString().slice(0,10);
            },
            exportOptions: {
              columns: [0, 1, 2, 3, 4, 5], // Export all columns except Actions
              format: {
                body: function(data, row, column, node) {
                  // Handle the "Charge TeleSoft" column (column index 5)
                  if (column === 5) {
                    // Get the data-order attribute which contains the boolean value
                    const hasCharge = $(node).closest('tr').attr('data-has-charge');
                    return hasCharge === 'true' ? 'Oui' : 'Non';
                  }
                  // For other columns, remove HTML tags and return clean text
                  return data.replaceAll(/<[^>]*>/g, '').trim();
                }
              }
            }
          }
        ]
      });
  
      // Store original data for filtering
      this.originalData = this.table.rows().data().toArray();

      this.table.on('draw', () => {
        $("#invoice-management-datatable_filter").hide(); // Hide the default search box
      });
    }
  
    bindEvents() {
      // Custom search functionality
      $('#customSearch').on('keyup', () => {
        this.table.search($('#customSearch').val()).draw();
      });
  
      // Clear search
      $('#customSearch').on('search', () => {
        if ($('#customSearch').val() === '') {
          this.table.search('').draw();
        }
      });
  
      // Switch filter for orders without charge created
      $('#filterNoChargeSwitch').on('change', () => {
        this.filterByChargeStatus();
      });
    }

    bindChargeCreationModal() {
      // No additional logic needed since each modal is pre-populated with order data
      // The data-target attribute on each button will open the correct modal
    }

    loadOrderDetailsForModal(orderId) {
      // Find the order row in the table
      const orderRow = $(`button[data-order-id="${orderId}"]`).closest('tr');
      
      // Extract order details from the table row
      const serviceNumber = orderRow.find('td:nth-child(1) a').text().trim();
      const entity = orderRow.find('td:nth-child(4)').text().trim();
      const customerEntity = orderRow.find('td:nth-child(5)').text().trim();
      const orderDate = orderRow.find('td:nth-child(3)').text().trim();
      
      // Populate the order summary in the modal
      const orderSummaryHtml = `
        <div class="row">
          <div class="col-md-6">
            <p><strong>N° service :</strong> ${serviceNumber}</p>
            <p><strong>Entité :</strong> ${entity}</p>
            <p><strong>Date de commande :</strong> ${orderDate}</p>
          </div>
          <div class="col-md-6">
            <p><strong>Client final :</strong> ${customerEntity}</p>
          </div>
        </div>
      `;
      
      $('#order-summary-body').html(orderSummaryHtml);
      
      // Update the form action URL
      const formActionUrl = `/invoice_management/${orderId}/create-telesoft-charge`;
      $('#charge-creation-form').attr('action', formActionUrl);
      
      // Update modal title to include service number
      $('#chargeCreationModalTitle').text(`Création de charge TeleSoft - ${serviceNumber}`);
    }
  
    filterByChargeStatus() {
      const showOnlyNoCharge = $('#filterNoChargeSwitch').is(':checked');
      
      if (showOnlyNoCharge) {
        // Show only rows where data-has-charge="false"
        $.fn.dataTable.ext.search.push((settings, data, dataIndex) => {
          const row = this.table.row(dataIndex).node();
          return $(row).attr('data-has-charge') === 'false';
        });
      } else {
        // Remove the custom filter to show all rows
        $.fn.dataTable.ext.search.pop();
      }
      
      this.table.draw();
    }
  
    onDataChanged(data) {
      // Handle data changes if needed
    }
  
    onDestroy() {
      // Clean up custom search filters
      $.fn.dataTable.ext.search = [];
      
      if (this.table) {
        this.table.destroy();
      }
    }
  }